import { hotComments } from '@/mocks/articles';

export default function CommentWaterfall() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="mb-8 md:mb-10">
        <span className="inline-block text-xs font-bold uppercase tracking-wider text-primary-600 bg-primary-50 px-3 py-1 rounded-full">
          实时讨论
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
          网友热评
          <span className="block font-body text-lg md:text-xl italic text-foreground-400 font-light mt-1">
            吃瓜群众都怎么说
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {hotComments.map((comment, index) => (
          <div
            key={comment.id}
            className="bg-background-50 rounded-lg p-4 md:p-5 transition-all duration-300 hover:-translate-y-1"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={comment.avatar}
                  alt={comment.nickname}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-bold text-foreground-900 truncate">{comment.nickname}</p>
                <p className="text-xs text-foreground-400">@user_{comment.id}</p>
              </div>
            </div>
            <div className="mt-3 md:mt-4">
              <p className="text-sm text-foreground-600 leading-relaxed">
                <span className="text-primary-400 text-lg leading-none">&ldquo;</span>
                {comment.content}
                <span className="text-primary-400 text-lg leading-none">&rdquo;</span>
              </p>
            </div>
            <div className="mt-3 md:mt-4 flex items-center justify-between text-xs text-foreground-400">
              <span>{comment.time}</span>
              <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-thumb-up-line"></i>
                {comment.likes}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}